import { deleteSmartList as _deleteSmartList } from '@griply/services';
import { deleteDoc, doc, getFirestore } from 'firebase/firestore';
import {
  FirestoreWriteOp,
  logFirestoreWriteError,
} from 'shared/services/error-tracking';
import { ID } from 'shared/types/id';

export const deleteSmartList = async (
  _userId: ID,
  smartListId: ID,
): Promise<void> =>
  _deleteSmartList({
    smartListId,
    db: getFirestore(),
    doc,
    deleteDoc,
    onWriteError: (error) =>
      logFirestoreWriteError({
        op: FirestoreWriteOp.DeleteSmartList,
        error,
        docPath: `smart-lists/${smartListId}`,
      }),
  });
